import PropTypes from 'prop-types';

export const Harp_Logo = ({ width = '150', height = '123' }) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 1200 981'
        fill='none'
        xmlns='http://www.w3.org/svg'
    >
        <path
            d='M0 250C0 111.929 111.929 0 250 0H950C1088.07 0 1200 111.929 1200 250C1200 388.071 1088.07 500 950 500H250C111.929 500 0 388.071 0 250Z'
            fill='url(#paint0_linear_2508_9972)'
        />
        <path
            d='M253.864 897.366C169.699 813.203 169.699 676.745 253.864 592.581L773.221 73.2234C870.853 -24.4078 1029.14 -24.4078 1126.77 73.2234C1224.41 170.854 1224.41 329.145 1126.77 426.776L656.183 897.366C545.086 1008.47 364.961 1008.47 253.864 897.366Z'
            fill='url(#paint1_linear_2508_9972)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_2508_9972'
                x1='600'
                y1='0'
                x2='600'
                y2='500'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#FBC7D4' />
                <stop offset='1' stopColor='#9796F0' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_2508_9972'
                x1='525.734'
                y1='320.71'
                x2='879.287'
                y2='674.264'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#FBC7D4' />
                <stop offset='1' stopColor='#9796F0' />
            </linearGradient>
        </defs>
    </svg>
);

Harp_Logo.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string
};
